// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"810ac94e","112":"a4608e01","229":"39c3cacb","445":"6d40571e","517":"9860712f","640":"fd43b884","643":"02c01b2c","727":"847ad8d5","932":"08705573","941":"103f7230","956":"d76a0582"}[chunkId] + ".chunk.js";
};